::ng-deep mat-checkbox .mat-checkbox-layout{align-items:start}::ng-deep mat-checkbox .mat-checkbox-inner-container{top:3px}
/*# sourceMappingURL=consultant-archive-dialog.component-3JKWE2AM.css.map */
